/* global axios */
import ApiClient from '../ApiClient';

class CaptainCitizenComplaintCategories extends ApiClient {
  constructor() {
    super('captain/citizen_complaint_categories', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }

  create(data) {
    return axios.post(this.url, { citizen_complaint_category: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, {
      citizen_complaint_category: data,
    });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new CaptainCitizenComplaintCategories();
